import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import styles from '../../login/LoginForm/LoginForm.module.css';
import accessKeyFlow from '../hook';

const AccessKeyForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [data, setData] = useState({
    accesskey: '',
    role: 'admin',
  });

  const handleModalText = (text) => {
    setModalText(text);
  };
  const validateAccessKey = accessKeyFlow();

  const handleResponseMessage = (text) => {
    setResponseMessage(text);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    const accessKey = data.accesskey;
    if (accessKey !== '') {
      validateAccessKey({
        accessKey,
        changeModalText: handleModalText,
        setShowModal,
        changeResponseMessage: handleResponseMessage,
      });
    }
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form id={styles['login-form']} onSubmit={handleSubmit}>
      <p>
        Your KYC is pending. Please{' '}
        <a href="mailto:partnership@fewcents.co"> contact partnership </a> for
        more information
      </p>
      <input
        required
        type="text"
        name="accesskey"
        onChange={handleChange}
        value={data.accesskey}
        placeholder="Your Access Key"
        className={styles['login-form__input']}
      />
      <input
        type="submit"
        value="Validate"
        disabled={data.accesskey === ''}
        id={styles['login-form__submit']}
      />

      <ValidationResult message={responseMessage} />

      {showModal && (
        <RegisterModal setShowModal={setShowModal} text={modalText} />
      )}
    </form>
  );
};

const ValidationResult = ({ message }) => <label id={styles['err-message']}>{message}</label>;
ValidationResult.propTypes = {
  message: PropTypes.node.isRequired,
};

const RegisterModal = ({ setShowModal, text }) => (
  <Modal setShowModal={setShowModal} isLogin>
    <p>{text}</p>
  </Modal>
);
RegisterModal.propTypes = {
  setShowModal: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
};

export default AccessKeyForm;
